<template>
  <v-card class="pa-8 px-10 mt-8" elevation="1">
    <v-row>
      <v-col cols="9" class="pa-0">
        <h2 v-html="$t('page-rules.manage.section-seasonal-rules.title')" class="font-weight-regular pb-2"></h2>
        <p v-html="$t('page-rules.manage.section-seasonal-rules.subtitle')" class="body-2 grey--text text--darken-1"></p>
      </v-col>
      <v-col class="text-right pa-0">
        <v-btn v-html="$t('page-rules.manage.section-seasonal-rules.actions.add.label')" color="primary" outlined :to="{name: 'place-rules-seasonal-create'}"></v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="px-0">
        <seasonal-data-table :place="place" :seasonalBookingRules="seasonalBookingRules"/>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import SeasonalDataTable from './SeasonalDataTable.vue'

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
    seasonalBookingRules: {
      type: Array,
      required: true,
    },
  },
  components: {
    SeasonalDataTable,
  },
}
</script>
